import React, { useState } from "react";
import { X, CheckCircle } from "lucide-react";
import { toast } from "react-hot-toast";

const TaskUpdateDialog = ({ isOpen, onClose, task, onUpdate }) => {
  const [status, setStatus] = useState(task?.status || "PENDING");
  const [comments, setComments] = useState("");
  const [loading, setLoading] = useState(false);

  const statusOptions = [
    { value: "PENDING", label: "Pending" },
    { value: "IN_PROGRESS", label: "In Progress" },
    { value: "COMPLETED", label: "Completed" },
    { value: "CANCELLED", label: "Cancelled" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await onUpdate(task._id, { status, comments });
      toast.success("Task status updated successfully!");
      onClose();
    } catch (error) {
      console.error("Error updating task:", error);
      toast.error("Failed to update task status");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !task) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-[#131313] rounded-lg p-6 w-full max-w-md border border-[#333333]">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-white">Update Task Status</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            <X size={20} />
          </button>
        </div>

        <div className="mb-4">
          <h4 className="text-white font-medium mb-2">{task.title}</h4>
          <p className="text-gray-400 text-sm mb-2">{task.description}</p>
          <div className="flex items-center gap-2 text-xs">
            <span className="text-gray-500">Priority:</span>
            <span className="text-white">{task.priority}</span>
            <span className="text-gray-500">•</span>
            <span className="text-gray-500">Type:</span>
            <span className="text-white">{task.type}</span>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-gray-300 mb-2">Status</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="w-full bg-[#131313] border border-[#333333] rounded px-3 py-2 text-white"
            >
              {statusOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm text-gray-300 mb-2">Comments (Optional)</label>
            <textarea
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              placeholder="Add any comments about this update..."
              className="w-full bg-[#131313] border border-[#333333] rounded px-3 py-2 text-white h-20 resize-none"
            />
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-400 hover:text-white"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 bg-yellow-500 text-black rounded hover:bg-yellow-400 disabled:opacity-50 flex items-center gap-2"
            >
              {loading ? "Updating..." : "Update"}
              <CheckCircle size={16} />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TaskUpdateDialog;